"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16ThumbsDownLine = function Svg16ThumbsDownLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.61 13.987a5.31 5.31 0 0 0-.58.622c-.675.852-1.217 2.056-1.217 3.607a1 1 0 0 1-.302.716c-.17.166-.386.28-.514.345-.157.08-.336.157-.515.229-.357.144-.768.287-1.111.402a1.776 1.776 0 0 1-2.297-1.284c-.213-.914-.547-2.527-.622-4.004l-.542-.048a2.647 2.647 0 0 1-2.31-3.376l.943-3.241a4.294 4.294 0 0 1 2.488-2.77l.966-.399c.889-.366 1.964-.63 3.081-.399.747.155 1.524.397 2.22.651a1.822 1.822 0 0 1 1.525-.824h2.354c1.007 0 1.823.817 1.823 1.824v6.588a1.824 1.824 0 0 1-1.823 1.824h-2.354c-.466 0-.891-.175-1.213-.463zm-3.875 3.664c-.233.093-.504.192-.767.282-.256-1.14-.581-2.9-.525-4.186a1 1 0 0 0-.911-1.04l-1.447-.127a.647.647 0 0 1-.565-.825l.944-3.241a2.294 2.294 0 0 1 1.329-1.48l.966-.398c.703-.29 1.346-.408 1.914-.29.776.16 1.615.44 2.327.717v4.861a7.062 7.062 0 0 0-1.536 1.442 7.654 7.654 0 0 0-1.63 4.244 6.287 6.287 0 0 1-.099.04zM18 6.214v6.236h-2V6.214h2z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16ThumbsDownLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16ThumbsDownLine;
exports.default = _default;